import { type MutableRefObject, useCallback, useEffect } from 'react';

export function useOutsideClick<E extends HTMLElement>(
  callback: (event: MouseEvent) => boolean | void,
  ref: MutableRefObject<E>,
  deps: unknown[] = [],
  shouldListen = true,
) {
  const handler = useCallback(
    (event: MouseEvent) => {
      if (!shouldListen || !ref.current) return;
      if (ref.current.contains(event.target as Node)) {
        return;
      }
      event.stopPropagation();
      return callback(event);
    },
    [...deps],
  );

  useEffect(() => {
    document.addEventListener('click', handler, { passive: true });
    return () => document.removeEventListener('click', handler);
  }, [handler]);
}
